import { useDark, useToggle } from '@vueuse/core'

const isDark = useDark({
    storageKey: 'theme'
})
const toggleDark = useToggle(isDark)

interface ToggleTheme {
  toggleTheme(): void;
  themeDark(): boolean;
  getIconColor(): string,
}

export default function useToggleTheme () : ToggleTheme {
  function toggleTheme (): void {
    toggleDark()
  }
  function themeDark (): boolean {
    return isDark.value
  }
  function getIconColor (): string {
    if (isDark.value) {
      return 'white'
    }
    return 'black'
  }
  return { toggleTheme, themeDark, getIconColor }
}
